import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Result } from '@/entities';
import { matchKeys } from '@/hooks/matches/matchKeys';
import { rotationsInfoKeys } from '@/hooks/tie-breaker/rotationsInfoKeys';
import { updateMatch, UpdateMatchData } from '@/services/actions/updateMatch';

interface UseUpdateMatchMutationOptions {
	onSuccessCallback?: () => void;
	isTieBreaker?: boolean;
	matchupId?: string;
	doNotRefetch?: boolean;
}

export const useUpdateMatchMutation = (options?: UseUpdateMatchMutationOptions) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (data: UpdateMatchData) => updateMatch(data),
		onError: (error: Error) => {
			toast.error(error.message || 'Unable to update match. Please try again.', {
				autoClose: 2000
			});
		},
		onSuccess: (result?: Result<void>) => {
			if (result?.statusCode === 200) {
				if (options?.matchupId && !options.doNotRefetch) {
					queryClient.invalidateQueries({ queryKey: matchKeys.matches(options.matchupId) });
				}

				if (options?.isTieBreaker && options?.matchupId) {
					queryClient.invalidateQueries({
						queryKey: rotationsInfoKeys.rotationsInfo(options.matchupId)
					});
				}

				if (options?.onSuccessCallback) {
					options.onSuccessCallback();
				}
			} else {
				toast.error(result?.error || 'Unable to update match. Please try again.');
			}
		}
	});
};
